export function backendEndpoint() {
    const endpoint = process.env.NEXT_PUBLIC_BACKEND_ENDPOINT;
    if (!endpoint) {
        throw new Error("Missing value for environment variable BACKEND_ENDPOINT");
    }
    return endpoint;
}
export const FALLBACK_ORIGIN = "https://www.snapchat.com";
